import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";

function Loader({ theme, text }) {
  return (
    <motion.div
      className="fixed inset-0 flex items-center justify-center z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div
        className={`${theme.contentBg} p-4 rounded-lg shadow-xl flex items-center gap-3`}
      >
        <Loader2 className={`${theme.iconColor} animate-spin`} size={24} />
        <span className={`${theme.sidebarText} text-sm font-medium`}>
          {text}
        </span>
      </div>
    </motion.div>
  );
}

export default Loader;
